import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import {  grupoProducto } from './grupoProducto';

@Injectable({
  providedIn: 'root'
})
export class GrupoProductoService {



  constructor(private http: HttpClient) { }

 
  getGrupo(idEmisor: string) {  
    
    return this.http.get<grupoProducto[]>(environment.apiUrl+"/listarTipoProducto/?id=" + idEmisor);  
  }  

  getUnidad(idUnidad: string) {  
    
    return this.http.get<grupoProducto[]>(environment.apiUrl+"/listarTipoProducto/?id=" + idUnidad);  
  }  

  getGrupoCompra(idEmisor: string) {  
    
    return this.http.get<grupoProducto[]>(environment.apiUrl+"/listarTipoProducto/?id=" + idEmisor);  
  }  

  

  setActulizar(Grupo: grupoProducto[]){
    console.log(Grupo);
    return this.http.put<string>(environment.apiUrl+"/actulizarTipoProducto",Grupo)
  }

  eliminar(id: number){

    return this.http.delete<void>(environment.apiUrl+"/eliminarTipoProducto/?id="+id);
  }
  
}
